import { extend, $, $$ } from './helper-functions'
import 'leaflet'

export class MapVariant2 {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      map: '.map--variant-2',
      leaflet: '.leaflet__map'
    }, selectors)

    this.classes = extend({
    }, classes)

    this.maps = $$(this.selectors.map)
  }

  init () {
    this.maps.forEach(map => {
      const leafletMap = $(this.selectors.leaflet, map)
      const L = window.L

      const osm = new L.TileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          opacity: 0.7,
          attribution: [
            'Map data &copy; <a href="https://openstreetmap.org/" target="_blank">OpenStreetMap</a> contributors',
            'POI via <a href="https://www.overpass-api.de/" target="_blank">Overpass API</a>'
          ].join(', ')
        }
      )

      const latitude = leafletMap.dataset.latitude
      const longitude = leafletMap.dataset.longitude

      const leafletMapInstance = new L.Map(leafletMap.id)
        .addLayer(osm)
        .setView(new L.LatLng(latitude, longitude), 16)

      L.marker([latitude, longitude], {
        icon: L.divIcon({
          className: 'map__poi',
          html: '<img src="/app/themes/covivio/images/leaflet/poi.svg" width="33" height="66" loading="lazy">'
        })
      }).addTo(leafletMapInstance)
    })
  }
}

export default MapVariant2
